// Public privacy policy page (no auth) — the URL entered in the Play Console
// and linked from the mobile app. Route: /privacy
export default function Privacy() {
  const updated = "June 2026";
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="mx-auto max-w-3xl px-6 py-12">
        <h1 className="text-3xl font-bold" data-testid="privacy-title">Privacy Policy</h1>
        <p className="mt-2 text-sm text-muted-foreground">American Scale Company — amscaledata · Last updated {updated}</p>

        <div className="mt-8 space-y-6 text-[15px] leading-7">
          <section>
            <p>
              amscaledata is a business tool used by American Scale Company and its field technicians to view
              and manage customer service records, invoices, routes and equipment photos. This policy explains
              what information the app handles and how it is used. The app is intended for authorized staff, not
              the general public.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold">Information we collect</h2>
            <ul className="mt-2 list-disc space-y-1 pl-6">
              <li><strong>Account information</strong> — your name and email address, used to sign you in and apply your access permissions.</li>
              <li><strong>Business records</strong> — customer, invoice, route and service data that the company stores and that you view or edit in the app.</li>
              <li><strong>Photos</strong> — images you capture with the camera or select to attach to a customer's folder.</li>
              <li><strong>Device &amp; connection state</strong> — basic network status used to support offline viewing and to sync your changes when you reconnect.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold">How we use information</h2>
            <p className="mt-2">
              Information is used solely to provide the service: authenticating you, showing your assigned data,
              saving your edits and photos, generating invoices and statements, and keeping the mobile and web
              apps in sync. We do not use your data for advertising, and we do not sell it.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold">Sharing</h2>
            <p className="mt-2">
              Data is shared only with the service providers needed to operate the app — for example QuickBooks
              Online, when the company connects it, to sync invoices, customers and payments. We do not share
              your data with any other third parties except as required by law.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold">Permissions</h2>
            <p className="mt-2">
              The app requests camera access to photograph equipment and scan documents, and photo access to
              attach existing images to a customer's folder. These prompts appear only when you choose an action
              that needs them, and access can be changed at any time in your device settings.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold">Data retention &amp; account deletion</h2>
            <p className="mt-2">
              Accounts are created and managed by American Scale Company administrators. To request access to,
              correction of, or deletion of your account and associated personal data, contact us at the address
              below and we will action the request and delete the associated data.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold">Contact</h2>
            <p className="mt-2">
              American Scale Company · P.O. Box 900, Chandler, TX 75758 · {" "}
              <a className="text-primary underline" href="mailto:Admin@americanscaletexas.com">Admin@americanscaletexas.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
